// timelapseWorkerFactory — the one place that touches Vite's `?worker`
// import for the timelapse worker. Kept out of `generateTimelapseVideo.ts`
// so that module stays importable in the vitest node env (same policy as
// `CanvasDrawingEngine`'s injected `workerFactory` — Vite resolves
// `?worker` at build time and splits `timelapseWorker.ts` + its imports
// (drawing-core replay, mp4-muxer) into a lazily-fetched chunk that never
// weighs on the main bundle).
//
// T3 wires this factory into `generateTimelapseVideo({ workerFactory:
// createTimelapseWorker, ... })`; tests inject fakes instead.

import TimelapseWorkerCtor from './timelapseWorker.js?worker';

export const createTimelapseWorker = (): Worker => new TimelapseWorkerCtor();
